import React from "react"
import { BrowserRouter as Router, Switch, Route, HashRouter } from "react-router-dom"
import Login from '../component/Login'
import { createBrowserHistory } from "history"
// import Dashboard from '../views/dashboard'
import User from '../views/User'
import Userlogin from '../component/Userlogin'
import Landing from "../views/Landing"
import UserSignup from "../component/UserSignup/index"
import ForgotPassword from "../component/UserForgotPassword"
import UpdatePassword from "../component/UserUpdatePassword/index"
const Routes = () => {
  const hist = createBrowserHistory()

  return (
    <div>
      <HashRouter history={hist}>
      <Switch>
          <Route path="/" exact component={Userlogin} />
        </Switch>
        <Switch>
          <Route path="/user" exact component={User} />
        </Switch>
        <Switch>
          <Route path="/login" exact component={Login} />
        </Switch>
        <Switch>
          <Route path="/dashboard" exact component={Landing} />
        </Switch>
        <Switch>
          <Route path="/usersignup" exact component={UserSignup} />
        </Switch>
        <Switch>
          <Route path="/forgotpassword" exact component={ForgotPassword} />
        </Switch>
        <Switch>
          <Route path="/updatepassword" exact component= {UpdatePassword} />
        </Switch>
        {/* <Switch>
          <Route path="/Dashboard" exact component={Dashboard} />
        </Switch> */}
      </HashRouter>
    </div>
  )
}
export default Routes





// import React, { useState } from "react"
// import Select from 'react-select';
// import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
// import { ToastContainer, toast } from 'react-toastify';
// import { useHistory } from "react-router-dom"
// import 'react-toastify/dist/ReactToastify.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Autocomplete from 'react-google-autocomplete';
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
// import 'react-google-places-autocomplete/dist/index.min.css';
// import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

// const Adddoctor = () => {
//     toast.configure()

//     const [addDoctorValues, setAddDoctorValues] = useState({
//         email: "",
//         practiceEmail: "",
//         firstName: "",
//         lastName: "",
//         phone: "",
//         centerName: "",
//         websiteURL: "",
//         Address: "",
//         zip: "",
//         latLong: ""
//     })
//     const handleEmail = (input) => {
//         const emailValue = { ...addDoctorValues, email: input.target.value }
//         setAddDoctorValues(emailValue)
//     }

//     const handlePracticeEmail = (input) => {
//         const emailValue = { ...addDoctorValues, practiceEmail: input.target.value }
//         setAddDoctorValues(emailValue)
//     }

//     const handleFirstName = (input) => {
//         const nameValue = { ...addDoctorValues, firstName: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handleLastName = (input) => {
//         const nameValue = { ...addDoctorValues, lastName: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handlePhone = (input) => {
//         const nameValue = { ...addDoctorValues, phone: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handleCenterName = (input) => {
//         const nameValue = { ...addDoctorValues, centerName: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handleWebsite = (input) => {
//         const nameValue = { ...addDoctorValues, websiteURL: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handleAddess = (address) => {
//         const nameValue = { ...addDoctorValues, Address: address.description }
//         console.log("000000000000", nameValue)
//         // let address = nameValue.Address
//         geocodeByAddress('Mohali, Punjab')
//             .then(results => getLatLng(results[0]))
//             .then(({ lat, lng }) =>
//                 console.log('Successfully got latitude and longitude', { lat, lng })
//             );
//         setAddDoctorValues(nameValue)
//     }

//     const handleZip = (input) => {
//         const nameValue = { ...addDoctorValues, zip: input.target.value }
//         setAddDoctorValues(nameValue)
//     }

//     const handleLatLong = (input) => {
//         const nameValue = { ...addDoctorValues, latLong: input.target.value }
//         setAddDoctorValues(nameValue)
//     }
//     const handleSubmit = () => {
//         if (addDoctorValues.email === "" || addDoctorValues.practiceEmail === "" || addDoctorValues.firstName === "" || addDoctorValues.lastName === "" || addDoctorValues.phone === "" || addDoctorValues.centerName === "" || addDoctorValues.websiteURL === "" || addDoctorValues.Address === "" || addDoctorValues.zip === "" || addDoctorValues.latLong === "") {
//             notify("error")
//         }
//     }
//     const notify = msg => {
//         if (msg == "error") {
//             toast.error("Please fill the data")
//         } else if (msg == "success") {
//             toast.success("Login successfully")
//         } else if (msg == "emailerror") {
//             toast.error("Please fill the valid email format")
//         }
//     }
//     console.log("object", addDoctorValues)
//     return (
//         <div className="datatata">
//             <Form>
//                 <FormGroup>
//                     <Label for="exampleEmail">Email</Label>
//                     <Input type="email" name="email" id="exampleEmail" placeholder="with a placeholder"
//                         onChange={e => handleEmail(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleEmail">PractiseEmail</Label>
//                     <Input type="email" name="email" id="exampleEmail" placeholder="with a placeholder"
//                         onChange={e => handlePracticeEmail(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">First Name</Label>
//                     <Input type="textarea" name="text" id="exampleText"
//                         onChange={e => handleFirstName(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">Last Name</Label>
//                     <Input type="textarea" name="text" id="exampleText"
//                         onChange={e => handleLastName(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">Phone Number</Label>
//                     <Input type="number" name="number" id="exampleText"
//                         onChange={e => handlePhone(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">center Name</Label>
//                     <Input type="textarea" name="text" id="exampleText"
//                         onChange={e => handleCenterName(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">Website URL</Label>
//                     <Input type="textarea" name="text" id="exampleText"
//                         onChange={e => handleWebsite(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">Address</Label>
//                     <GooglePlacesAutocomplete
//                         onSelect={e => handleAddess(e)}
//                     />
//                     {/* onChange={e => handleAddess(e)} /> */}
//                 </FormGroup>

//                 <FormGroup>
//                     <Label for="exampleText">Zip</Label>
//                     <Input type="number" name="number" id="exampleText"
//                         onChange={e => handleZip(e)} />
//                 </FormGroup>
//                 <FormGroup>
//                     <Label for="exampleText">Lat/Long</Label>
//                     <Input type="textarea" name="text" id="exampleText"
//                         onChange={e => handleLatLong(e)} />
//                 </FormGroup>
//                 <Button onClick={e => handleSubmit(e)}>Submit</Button>
//             </Form>
//         </div>
//     )
// }

// export default Adddoctor




// WEBPACK FOOTER //
// ./src/routes/index.js